// Core
import { createSlice } from '@reduxjs/toolkit';

const fileSlice = createSlice({
    name: 'fileData',
    initialState: {
        dbfFileData: null,
        signedEcpData: null,
        signRequestState: null,
        signURL: null,
        isFileUpdated: false,
        fileState: null,
    },
    reducers: {
        setDbfFileData: (state, action) => {
            state.dbfFileData = action.payload;
        },
        setSignedEcpData: (state, action) => {
            state.signedEcpData = action.payload;
        },
        clearFileData: (state, action) => {
            state.dbfFileData = null;
            state.signedEcpData = null;
        },
        setSignRequestState: (state, action) => {
            state.signRequestState = 'OK';
        },
        clearSignRequestState: (state, action) => {
            state.signRequestState = null;
        },
        saveQrCodeSignURL: (state, action) => {
            state.signURL = action.payload;
        },
        clearQrCodeSignURL: (state) => {
            state.signURL = null;
        },
        setUpdateFileData: (state, action) => {
            state.dbfFileData.savedRows = state.dbfFileData.savedRows.map((item) => {
                if (item.id === action.payload.id) {
                    return action.payload;
                }
                return item;
            });
        },
        setIsFileUpdated: (state, action) => {
            state.isFileUpdated = action.payload;
        },
        setFileState: (state, action) => {
            state.fileState = action.payload;
        },
        clearFileState: (state) => {
            state.fileState = null;
        },
    },
});

export const {
    setDbfFileData,
    setSignedEcpData,
    clearFileData,
    setSignRequestState,
    clearSignRequestState,
    saveQrCodeSignURL,
    clearQrCodeSignURL,
    setUpdateFileData,
    setIsFileUpdated,
    setFileState,
    clearFileState,
} = fileSlice.actions;

export default fileSlice.reducer;
